import { useEffect, useState, useRef } from 'react';
import axios from 'axios'
import { useError } from "../state/error";
import { baseUrl } from '../lib/constants';

export const useFetch = (url, reload = false) => {
  const isCurrent = useRef(true);
  const [state, setState] = useState({
    data: null,
    loading: true,
    totalCount: null
  });
  const { setIsError } = useError();

  // Get auth tokens inside useEffect to handle token updates
  const getAuthHeaders = () => {
    const tokens = JSON.parse(localStorage.getItem('tokens'));
    return tokens?.token ? { Authorization: tokens.token } : {};
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState(prevState => {
      const newData = { ...prevState.data };
      
      if (name.includes('.')) {
        const [key1, key2] = name.split('.');
        newData[key1] = { 
          ...newData[key1],
          [key2]: value 
        };
      } else {
        newData[name] = value;
      }
      
      return {
        ...prevState,
        data: newData
      };
    });
  };

  useEffect(() => {
    return () => { 
      isCurrent.current = false;
    };
  }, []);

  useEffect(() => {
    if (!url || url.includes('undefined') || url.includes('null')) {
      return;
    }

    setState(prevState => ({ 
      ...prevState, 
      loading: true 
    }));

    axios.get(`${baseUrl}/${url}`, { 
      headers: getAuthHeaders() 
    })
    .then(response => {
      if (!isCurrent.current) return;

      if (response.status === 200 || response.data?.data?.status === 200) {
        setState({
          data: response.data.data,
          loading: false,
          totalCount: response.data.totalCount
        });
      } else {
        setIsError(response.data.data);
      }
    })
    .catch(error => {
      if (isCurrent.current) {
        setIsError(error.message);
      }
    });
  }, [url, reload, setIsError]);

  return { ...state, handleChange };
};
